<template>
    <NConfigProvider
        :theme-overrides="themeOverrides"
        :locale="getNaiveLocale()"
        :date-locale="getNaiveDateLocale()"
    >
        <slot></slot>
    </NConfigProvider>
</template>

<script setup lang="ts">
import { getLocaleFromUrl } from "@src/i18n/utils";
import { CONFIG_OPTIONS as config } from "@src/globals";
import {
    NConfigProvider,
    GlobalThemeOverrides,
    deDE,
    dateDeDE,
    enGB,
    dateEnGB,
} from "naive-ui";

const primaryColor = config.cssVars["color-primary"];
const secondaryColor = config.cssVars["color-secondary"];
const primaryTextColor = config.cssVars["text-primary"];

const themeOverrides: GlobalThemeOverrides = {
    common: {
        primaryColor: primaryColor,
        primaryColorHover: primaryColor,
        textColorBase: primaryColor,
        railColor: secondaryColor,
    },
    Switch: {
        railColor: secondaryColor,
    },
    DatePicker: {
        itemTextColorActive: primaryTextColor,
    },
};

const locale = getLocaleFromUrl(new URL(window.location.href));

const getNaiveLocale = () => {
    switch (locale) {
        case "en":
            return enGB;
        default:
            return deDE;
    }
};

const getNaiveDateLocale = () => {
    switch (locale) {
        case "en":
            return dateEnGB;
        default:
            return dateDeDE;
    }
};
</script>
